// global
import React from 'react';
import PropTypes from 'prop-types';
// components
import DefaultButton from 'app/components/commons/button/defaultButton/DefaultButton';
// icons
import EditIcon from 'assets/icon/edit-icon/EditIcon';
// consts
import { COLORS } from 'app/config/colors';

function EditButton(props) {
  const { entity, onClickEdit, disabled } = props;

  return (
    <DefaultButton
      color={COLORS.ACCENTUATED_VARIANT}
      colorHover={COLORS.WHITE_VARIANT}
      backgroundColor={COLORS.WHITE_VARIANT}
      backgroundColorHover={COLORS.SECONDARY_VARIANT_MEDIUM}
      borderColor={COLORS.SECONDARY_VARIANT}
      borderColorHover={COLORS.SECONDARY_VARIANT}
      onClick={onClickEdit(entity)}
      icon={<EditIcon />}
      iconDisabled={<EditIcon fill='#BCBCBC' />}
      iconHover={<EditIcon />}
      size='medium'
      disabled={disabled}
    />
  );
}

EditButton.defaultProps = {
  disabled: false,
  onClickEdit: () => {}
};

EditButton.propTypes = {
  entity: PropTypes.object,
  disabled: PropTypes.bool,
  onClickEdit: PropTypes.func
};

export default EditButton;
